import React, { useMemo } from 'react';
import { MUIDataTable, MUIDataTableProps, MUIDataTableColumnDef } from 'web-library';

export interface CustomDataTableProps extends Omit<MUIDataTableProps, 'columns'> {
  dataTableType: 'list' | 'datatable';
  showHeaders?: boolean;
  columns: MUIDataTableColumnDef[] | string[];
}

const CustomDataTable: React.FC<CustomDataTableProps> = (props: CustomDataTableProps) => {
  const {
    columns,
    data,
    options,
    dataTableType = 'datatable',
    // downloadOption = false,
    // onDownload = () => null,
    showHeaders = true,
    components = undefined,
  } = props;

  const initColumns: MUIDataTableColumnDef[] = useMemo(() => {
    let dataCol = columns;
    if (dataTableType === 'list') {
      dataCol = columns.map((col) => {
        if (typeof col !== 'string') {
          return { ...col, options: { ...col.options, customHeadRender: () => null } };
        }
        return col;
      });
      return dataCol;
    }
    return dataCol;
  }, [columns, dataTableType]);

  const renderComponent = useMemo(() => {
    if (!showHeaders) {
      return { ...components, TableHead: <></> };
    }
    return undefined;
  }, [components, showHeaders]);

  return (
    <MUIDataTable
      columns={initColumns}
      data={data}
      options={options}
      components={renderComponent}
    />
  );
};
export default CustomDataTable;
